import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../web/components-v2/Theme/theme';

const { colors, typography, common } = THEME;

export const styleSheet = StyleSheet.create({
	activeLabel: {
		flex: 'none',
	},
	blitzPlayButton: {
		alignSelf: 'center',
		flex: 'none',
		height: THEME.space[40],
		padding: 0,
		width: 'auto',
	},
	blitzPlayImage: {
		height: THEME.space[40],
	},
	container: {
		alignItems: 'flex-start',
		background: colors.background.light,
		border: `1px solid ${colors.border.light}`,
		borderRadius: common.borderRadius,
		boxSizing: 'border-box',
		display: 'flex',
		fontSize: typography.fontSizes.sm,
		gap: THEME.space[16],
		margin: `0 0 ${THEME.space[12]}px`,
		maxWidth: 1000,
		padding: THEME.space[16],
		position: 'relative',
		width: '100%',
	},
	containerPlayable: {
		alignItems: 'center',
	},
	content: {
		display: 'flex',
		flex: 1,
		flexDirection: 'column',
		gap: THEME.space[12],
		minWidth: 0,
	},
	customRule: {
		alignItems: 'center',
		background: colors.background.dark,
		borderRadius: common.borderRadius,
		color: colors.text.dark,
		cursor: 'not-allowed',
		display: 'flex',
		fontSize: typography.fontSizes.lg,
		fontWeight: typography.fontWeights.bold,
		inset: 0,
		justifyContent: 'center',
		opacity: 0.9,
		position: 'absolute',
		zIndex: 2,
	},
	details: {
		display: 'flex',
		flexWrap: 'wrap',
		gap: THEME.space[24],
	},
	expired: {
		color: colors.danger.main,
	},
	infoPair: {
		display: 'inline-flex',
		gap: THEME.space[4],
		whiteSpace: 'nowrap',
	},
	infoTitle: {
		color: colors.text.light,
		margin: 0,
	},
	infoValue: {
		color: colors.text.main,
		fontWeight: typography.fontWeights.bold,
	},
	name: {
		color: colors.text.main,
		flex: 1,
		fontSize: typography.fontSizes.md,
		fontWeight: typography.fontWeights.bold,
		minWidth: 0,
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		whiteSpace: 'nowrap',
	},
	outcomeTypes: {
		color: colors.text.main,
		fontSize: typography.fontSizes.xs,
	},
	priority: {
		flex: 'none',
		width: THEME.space[48],
	},
	scheduleLine: {
		alignItems: 'baseline',
		display: 'flex',
		gap: THEME.space[4],
	},
	scheduleTitle: {
		color: colors.text.light,
		margin: 0,
		textTransform: 'uppercase',
	},
	separator: {
		color: colors.text.light,
		fontSize: typography.fontSizes.xs,
	},
	tagContainer: {
		alignItems: 'center',
		display: 'flex',
		flexWrap: 'wrap',
		gap: THEME.space[8],
	},
	titleRow: {
		alignItems: 'center',
		display: 'flex',
		gap: THEME.space[24],
	},
});
